module.exports = __webpack_public_path__ + "img/details.e16d33c9.svg";